import { set } from '@ember/object';
import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type HotelSettingsPosController from 'lumen/controllers/hotel/settings/pos';
import type { Transition } from 'lumen/services/transition';

export default class HotelSettingsPosRoute extends Route {
  @service declare navigation: Services['navigation'];

  beforeModel(transition: Transition): void {
    if (this.navigation.redirectToAccountSelection(transition)) {
      return;
    }
  }

  resetController(
    controller: HotelSettingsPosController,
    isExiting: boolean,
  ): void {
    if (isExiting) {
      set(controller, 'rsPosCountries', [
        {
          id: '',
          name: '',
          order: 1,
          countries: [],
        },
        {
          id: '',
          name: '',
          order: 2,
          countries: [],
        },
        {
          id: '',
          name: '',
          order: 3,
          countries: [],
        },
      ]);
    }
  }
}
